import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthSessionService } from '@features/auth/auth-session.service';
import { catchError, switchMap, throwError } from 'rxjs';
import { shouldSkipAuthRecovery } from './auth-endpoints';
import { SKIP_AUTH_ERROR_HANDLING } from './http-context.tokens';

export const RefreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authSession = inject(AuthSessionService);

  if (
    shouldSkipAuthRecovery(req.url) ||
    req.context.get(SKIP_AUTH_ERROR_HANDLING)
  ) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || !req.headers.has('Authorization')) {
        return throwError(() => error);
      }

      return authSession.refreshAccessToken().pipe(
        switchMap(accessToken => next(req.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`,
          },
        }))),
      );
    }),
  );
};
